(() => {
    const msg = document.querySelector('.urgent-msg');
    if (!msg) return;
    const hash = msg.getAttribute('data-hash');
    const check_multiline_msg = () => {
        if (msg.querySelector('span').getBoundingClientRect().height > 20) {
            msg.classList.add('multiline');
        } else {
            msg.classList.remove('multiline');
        }
    }
    if (window.localStorage.getItem('techne-sasg-' + hash)) {
        msg.classList.remove('display');
        return;
    } else {
        const mlInterval = setInterval(function() {
            check_multiline_msg();
        }, 100);
        window.addEventListener('resize', check_multiline_msg);
        msg.querySelector('label').addEventListener('click', () => {
            window.localStorage.setItem('techne-sasg-' + hash, 1);
            msg.querySelector('label').classList.add('checked');
            clearInterval(mlInterval);
            window.removeEventListener('resize', check_multiline_msg);
            setTimeout(() => {
                msg.classList.remove('display');
            }, 500);
        });
    }
})();